import React from 'react';
import PropTypes from 'prop-types';
import s from './Icon.module.scss';

const makeStyle = (size, url) => ({ height: size, width: size, backgroundImage: `url(${url})` });

const Icon = ({ size, url }) => {
    return <div className={s.categoryIcon} style={makeStyle(size, url)} />;
};

Icon.propTypes = {
    size: PropTypes.number,
    url: PropTypes.string,
};

Icon.defaultProps = {
    size: 100,
    url: '',
};

export default Icon;
